import { Box } from '@chakra-ui/react'
import {
  faCheckCircle,
  faClock,
  faExclamationCircle,
  faSync,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import Tippy from '@/components/UI/Tippy'

export function ApprovedIndicator({
  status,
}: {
  status: 'approved' | 'requires-change' | 'pending' | 'resubmitted'
}): JSX.Element {
  if (status === 'approved') {
    return (
      <Tippy content="Approved">
        <Box>
          <FontAwesomeIcon color={chakraTokenToVar('success.fg')} icon={faCheckCircle} />
        </Box>
      </Tippy>
    )
  }
  if (status === 'requires-change') {
    return (
      <Tippy content="Requires Changes (click the '...' icon for more info)">
        <Box>
          <FontAwesomeIcon color={chakraTokenToVar('fg.error')} icon={faExclamationCircle} />
        </Box>
      </Tippy>
    )
  }
  if (status === 'resubmitted') {
    return (
      <Tippy content="Updated Since Changes Requested">
        <Box>
          <FontAwesomeIcon color={chakraTokenToVar('yellow.solid')} icon={faSync} />
        </Box>
      </Tippy>
    )
  }
  return (
    <Tippy content="Pending Review">
      <Box>
        <FontAwesomeIcon color={chakraTokenToVar('fg.subtle')} icon={faClock} />
      </Box>
    </Tippy>
  )
}
